import EconomicCalendarTable from "@/ui-components/economic-calendar-table";
import useAuth from "@/hooks/useAuth";
import { CommonWidgetProps } from "../types";

/**
 * The calendar widget.
 *
 * `isDemo` shifts the table to the previous day and disables date navigation
 * — the same treatment the /calendar page has always applied. The widget was
 * not passing it, so for a logged-out visitor it asked for today (which is
 * behind the delay and therefore empty) and offered controls that led nowhere.
 * The underlying endpoint is public: /calendar_events?by_day=<yesterday>
 * answers 200 with a full day of events and no token.
 *
 * `widgetCompositeId` is what keeps two copies of the calendar on one
 * dashboard from sharing a country selection — the table keys its stored
 * filters on it.
 */
function EconomicCalendar({ widgetCompositeId }: CommonWidgetProps) {
  const { authenticated } = useAuth();
  return (
    <EconomicCalendarTable
      bodyRowClassNames="text-xs font-medium text-gray-900 dark:text-gray-100"
      widgetCompositeId={widgetCompositeId}
      isDemo={!authenticated}
    />
  );
}

export default EconomicCalendar;
